<template>
  <div id="sponsors">

    <div v-if="sponsor.type === type" class="sponsor" :class="classes(sponsor)" v-for="(sponsor, index) in sponsors" :key="index">
      <a v-if="sponsor.link" :href="sponsor.link" target="_blank">
        <img v-if="sponsor.src" :src="require(`../assets/${sponsor.src}`)">  
      </a>
        <img v-else :src="require(`../assets/${sponsor.src}`)">  

    </div>

  </div>
</template>

<script>

  import sponsors from '../scripts/sponsors';

  export default {
    data () {
      return {
        sponsors: sponsors
      }
    },
    methods: {
      classes (item) {
        return {
          [this.type]: true,
          wide: item.wide,
        }
      }
    },
    props: {
      type: {
        required: true
      }
    }
  }

</script>

<style lang="scss">

  #sponsors {
    padding: 50px;
    background: #FFF;
    text-align: center;

    @media screen and (max-width: 800px) {
      padding: 8px;
    }

    .sponsor {
      display: inline-block;
      margin: 20px;

      img {
        height: 100%;
      }

      &.platinum {
        height: 110px;
      }

      &.gold {
        height: 70px;

        &.wide {
          height: 50px;
        }
      }

      &.silver {
        height: 50px;

        &.wide {
          height: 35px;
        }
      }
    }
  }

</style>